/* eslint-disable camelcase */
import dayjs from 'dayjs';
import { refreshAccessToken as refreshAccessTokenNative } from 'actions/nativeAuth';
import { getStore } from '../store/configureStore';

export function credentialsNeedRefresh({ expires_at }) {
  const store = getStore();
  const { user } = store.getState();

  if (user.clock_offset > 600000) {
    console.warn('User clock offset is high', user.clock_offset);
  }

  // Has the token expired, or will it soon?
  return dayjs()
    .add(30, 'seconds')
    .subtract(user.clock_offset, 'millisecond')
    .isAfter(dayjs(expires_at));
}

export async function getAuthToken() {
  const store = getStore();
  const { user, device } = store.getState();

  // In cordova we don't use cookies
  let userState = user;
  if (userState.credentials && userState.credentials.access_token) {
    if (device.connected && credentialsNeedRefresh(userState.credentials)) {
      console.info('Token Refresh needed');
      // Refresh the user state
      await store.dispatch(refreshAccessTokenNative());
      userState = store.getState().user;
    }
    if (userState.credentials) {
      return userState.credentials.access_token;
    }
  }
  return null;
}

export default {
  getAuthToken,
  credentialsNeedRefresh,
};
